// Styles live inside the widget's Shadow DOM, so the host website's CSS cannot break the chat
// and the chat cannot affect the website.

export const WIDGET_CSS = `
:host { all: initial; }
* { box-sizing: border-box; }
[hidden] { display: none !important; }
.lb-root {
  --lb-accent: #6D28D9; --lb-on-accent: #fff;
  --lb-bg: #ffffff; --lb-surface: #f5f6f8; --lb-surface-2: #eceef2; --lb-text: #0f172a; --lb-muted: #64748b;
  --lb-border: rgba(15, 23, 42, .09); --lb-bubble-bot: #f1f3f6; --lb-shadow: 0 24px 60px -12px rgba(15, 23, 42, .28), 0 0 0 1px rgba(15, 23, 42, .06);
  --lb-radius: 20px; --lb-safe-bottom: env(safe-area-inset-bottom, 0px);
  position: fixed; bottom: 20px; right: 20px; z-index: 2147483000;
  font: 15px/1.45 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: var(--lb-text); -webkit-font-smoothing: antialiased; letter-spacing: -0.005em;
}
.lb-root[data-position="left"] { right: auto; left: 20px; }
.lb-root[data-theme="dark"] {
  --lb-bg: #15161b; --lb-surface: #1d1f26; --lb-surface-2: #262833; --lb-text: #f4f5f7; --lb-muted: #9aa1ad;
  --lb-border: rgba(255, 255, 255, .09); --lb-bubble-bot: #23252e; --lb-shadow: 0 24px 60px -12px rgba(0, 0, 0, .7), 0 0 0 1px rgba(255, 255, 255, .06);
}
button, input, textarea { font: inherit; color: inherit; }
button { cursor: pointer; }
:focus-visible { outline: 2px solid var(--lb-accent); outline-offset: 2px; }
.lb-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }

/* Launcher dock: contact buttons stacked above the chat button, so they always move together.
   Only the buttons take clicks; the empty corners of the dock let clicks reach the website. */
.lb-root { pointer-events: none; }
.lb-panel, .lb-label, .lb-launcher, .lb-contact { pointer-events: auto; }
.lb-dock { display: flex; flex-direction: column; align-items: flex-end; gap: 12px; }
.lb-root[data-position="left"] .lb-dock { align-items: flex-start; }
.lb-contacts { display: flex; flex-direction: column; gap: 10px; margin: 0 6px; transition: opacity .18s ease, transform .18s ease, visibility 0s linear 0s; }
.lb-root.lb-open .lb-contacts { opacity: 0; visibility: hidden; transform: translateY(8px); transition: opacity .15s ease, transform .15s ease, visibility 0s linear .15s; }
.lb-contact {
  --lb-contact: var(--lb-accent); position: relative; width: 46px; height: 46px; border-radius: 50%; display: grid; place-items: center;
  background: var(--lb-contact); color: #fff; text-decoration: none; box-shadow: 0 8px 22px -6px rgba(15, 23, 42, .4);
  transition: transform .2s ease; animation: lb-pop .3s cubic-bezier(.2, .9, .3, 1.2) both;
}
.lb-contact[data-channel="whatsapp"] { --lb-contact: #25D366; }
.lb-contact[data-channel="sms"] { --lb-contact: #2563EB; }
.lb-contact[data-channel="call"] { --lb-contact: #0D9488; }
.lb-contact[data-channel="email"] { --lb-contact: #EA580C; }
.lb-root[data-contacts="accent"] .lb-contact { --lb-contact: var(--lb-accent); color: var(--lb-on-accent); }
.lb-contact-tip {
  position: absolute; right: calc(100% + 10px); top: 50%; transform: translateY(-50%); white-space: nowrap;
  padding: 6px 10px; border-radius: 8px; background: var(--lb-bg); color: var(--lb-text); font-size: 12.5px; font-weight: 600;
  box-shadow: 0 6px 20px -6px rgba(15, 23, 42, .35), 0 0 0 1px var(--lb-border); opacity: 0; pointer-events: none; transition: opacity .15s ease;
}
.lb-root[data-position="left"] .lb-contact-tip { right: auto; left: calc(100% + 10px); }
.lb-launcher-row { display: flex; align-items: center; gap: 10px; justify-content: flex-end; }
.lb-root[data-position="left"] .lb-launcher-row { flex-direction: row-reverse; }
.lb-launcher {
  position: relative; width: 58px; height: 58px; border-radius: 50%; border: 0; display: grid; place-items: center;
  background: var(--lb-accent); color: var(--lb-on-accent); box-shadow: 0 10px 30px -6px rgba(15, 23, 42, .35);
  transition: transform .2s ease, box-shadow .2s ease;
}
.lb-launcher:hover { transform: translateY(-2px) scale(1.03); }
.lb-launcher svg { transition: transform .25s ease, opacity .2s ease; }
.lb-badge {
  position: absolute; top: -2px; right: -2px; min-width: 20px; height: 20px; padding: 0 6px; border-radius: 10px;
  background: #ef4444; color: #fff; font-size: 11px; font-weight: 700; display: grid; place-items: center; border: 2px solid #fff;
}
.lb-label {
  display: flex; align-items: center; gap: 8px; max-width: 240px; padding: 10px 12px 10px 14px; border-radius: 14px;
  background: var(--lb-bg); color: var(--lb-text); box-shadow: 0 8px 28px -8px rgba(15, 23, 42, .3), 0 0 0 1px var(--lb-border);
  font-size: 13.5px; font-weight: 600; animation: lb-pop .35s cubic-bezier(.2, .9, .3, 1.2);
}
.lb-label button { border: 0; background: transparent; color: var(--lb-muted); padding: 2px; border-radius: 6px; display: grid; }
.lb-label-text { cursor: pointer; }
.lb-dot { width: 8px; height: 8px; border-radius: 50%; background: #22c55e; box-shadow: 0 0 0 3px rgba(34, 197, 94, .18); flex-shrink: 0; }

/* Panel */
.lb-panel {
  position: absolute; bottom: 74px; right: 0; width: 392px; height: min(660px, calc(100vh - 110px));
  display: flex; flex-direction: column; overflow: hidden; border-radius: var(--lb-radius);
  background: var(--lb-bg); box-shadow: var(--lb-shadow);
  transform-origin: bottom right; transform: translateY(12px) scale(.96); opacity: 0; visibility: hidden;
  transition: transform .22s cubic-bezier(.2, .8, .2, 1), opacity .18s ease, visibility 0s linear .22s;
}
.lb-root[data-position="left"] .lb-panel { right: auto; left: 0; transform-origin: bottom left; }
.lb-root.lb-open .lb-panel { transform: none; opacity: 1; visibility: visible; transition-delay: 0s; }

.lb-header { display: flex; align-items: center; gap: 12px; padding: 14px 12px 14px 16px; border-bottom: 1px solid var(--lb-border); }
.lb-avatar {
  width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0; overflow: hidden; display: grid; place-items: center;
  background: var(--lb-accent); color: var(--lb-on-accent); font-weight: 700; font-size: 16px; position: relative;
}
.lb-avatar img { width: 100%; height: 100%; object-fit: cover; background: #fff; }
.lb-title { min-width: 0; flex: 1; }
.lb-title strong { display: block; font-size: 15.5px; font-weight: 650; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.lb-title span { display: flex; align-items: center; gap: 6px; color: var(--lb-muted); font-size: 12.5px; }
.lb-title .lb-dot { width: 7px; height: 7px; box-shadow: none; }
.lb-icon-btn { width: 36px; height: 36px; border: 0; border-radius: 10px; background: transparent; color: var(--lb-muted); display: grid; place-items: center; }
.lb-icon-btn:hover { background: var(--lb-surface); color: var(--lb-text); }
.lb-menu {
  position: absolute; top: 58px; right: 52px; min-width: 190px; padding: 6px; border-radius: 12px; background: var(--lb-bg);
  box-shadow: 0 12px 30px -8px rgba(15, 23, 42, .3), 0 0 0 1px var(--lb-border); z-index: 3;
}
.lb-menu button { width: 100%; text-align: left; border: 0; background: transparent; padding: 9px 10px; border-radius: 8px; font-size: 14px; }
.lb-menu button:hover { background: var(--lb-surface); }

.lb-body { flex: 1; overflow-y: auto; overscroll-behavior: contain; padding: 18px 16px 8px; scroll-behavior: smooth; }
.lb-body::-webkit-scrollbar { width: 6px; }
.lb-body::-webkit-scrollbar-thumb { background: var(--lb-surface-2); border-radius: 3px; }

/* Welcome form */
.lb-welcome { display: flex; flex-direction: column; gap: 14px; padding: 6px 4px; }
.lb-welcome h2 { margin: 0; font-size: 22px; line-height: 1.2; font-weight: 700; letter-spacing: -.02em; }
.lb-welcome p { margin: 0; color: var(--lb-muted); }
.lb-field { display: flex; flex-direction: column; gap: 6px; }
.lb-field label { font-size: 13px; font-weight: 600; }
.lb-field input {
  width: 100%; padding: 12px 14px; border-radius: 12px; border: 1px solid var(--lb-border); background: var(--lb-surface);
  font-size: 16px; outline: none; transition: border-color .15s, background .15s;
}
.lb-field input:focus { border-color: var(--lb-accent); background: var(--lb-bg); }
.lb-field[data-error] input { border-color: #ef4444; }
.lb-error { color: #ef4444; font-size: 12.5px; }
.lb-primary {
  border: 0; border-radius: 12px; padding: 13px 16px; background: var(--lb-accent); color: var(--lb-on-accent);
  font-weight: 650; font-size: 15px; transition: filter .15s, transform .1s;
}
.lb-primary:hover { filter: brightness(1.06); }
.lb-primary:active { transform: scale(.99); }
.lb-primary[disabled] { opacity: .6; cursor: default; }
.lb-fineprint { font-size: 12px; color: var(--lb-muted); text-align: center; }

/* Messages */
.lb-row { display: flex; gap: 8px; align-items: flex-end; margin-top: 4px; animation: lb-in .22s ease both; }
.lb-row.lb-new-group { margin-top: 14px; }
.lb-row.lb-me { justify-content: flex-end; }
.lb-mini { width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0; overflow: hidden; background: var(--lb-accent); color: var(--lb-on-accent); display: grid; place-items: center; font-size: 11px; font-weight: 700; }
.lb-mini img { width: 100%; height: 100%; object-fit: cover; background: #fff; }
.lb-mini.lb-hidden { visibility: hidden; }
.lb-stack { display: flex; flex-direction: column; gap: 8px; max-width: 82%; min-width: 0; }
.lb-me .lb-stack { align-items: flex-end; }
.lb-bubble { padding: 10px 14px; border-radius: 18px; background: var(--lb-bubble-bot); word-wrap: break-word; overflow-wrap: anywhere; }
.lb-bot .lb-bubble { border-bottom-left-radius: 6px; }
.lb-me .lb-bubble { background: var(--lb-accent); color: var(--lb-on-accent); border-bottom-right-radius: 6px; }
.lb-me .lb-bubble.lb-pending { opacity: .65; }
.lb-me .lb-bubble.lb-failed { background: #fee2e2; color: #991b1b; }
.lb-retry { border: 0; background: none; padding: 0 4px; font-size: 12px; font-weight: 600; color: #dc2626; text-decoration: underline; text-underline-offset: 2px; }
.lb-bubble p { margin: 0; }
.lb-bubble p + p, .lb-bubble p + ul, .lb-bubble ul + p { margin-top: 8px; }
.lb-bubble ul { margin: 6px 0 0; padding-left: 18px; }
.lb-bubble li + li { margin-top: 2px; }
.lb-bubble a { color: inherit; text-decoration: underline; text-underline-offset: 2px; }
.lb-bubble strong { font-weight: 650; }
.lb-time { font-size: 11px; color: var(--lb-muted); padding: 0 6px; }
.lb-notice { text-align: center; font-size: 12.5px; color: var(--lb-muted); margin: 14px 0 4px; }

/* Interactive elements */
.lb-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.lb-chip {
  border: 1px solid color-mix(in srgb, var(--lb-accent) 45%, transparent); background: var(--lb-bg); color: var(--lb-accent);
  border-radius: 999px; padding: 8px 14px; font-size: 14px; font-weight: 550; line-height: 1.2; text-align: left;
  transition: background .15s, color .15s, transform .1s;
}
.lb-root[data-theme="dark"] .lb-chip { color: var(--lb-text); }
.lb-chip:active { transform: scale(.97); }
.lb-chip[disabled] { opacity: .45; pointer-events: none; }
.lb-chip.lb-chosen { background: var(--lb-accent); color: var(--lb-on-accent); opacity: 1; }

.lb-services { display: grid; gap: 8px; width: 100%; }
.lb-service {
  display: flex; align-items: center; gap: 12px; width: 100%; padding: 12px 14px; border-radius: 14px; text-align: left;
  border: 1px solid var(--lb-border); background: var(--lb-bg); transition: border-color .15s, box-shadow .15s;
}
.lb-service-info { flex: 1; min-width: 0; }
.lb-service-info strong { display: block; font-size: 14.5px; font-weight: 650; }
.lb-service-info span { display: block; font-size: 12.5px; color: var(--lb-muted); }
.lb-service-price { font-weight: 700; font-size: 14px; color: var(--lb-accent); white-space: nowrap; }
.lb-root[data-theme="dark"] .lb-service-price { color: var(--lb-text); }

/* Optional extras: tick several, one tap adds them */
.lb-extras { width: 100%; display: grid; gap: 8px; border: 1px solid var(--lb-border); border-radius: 16px; padding: 12px; background: var(--lb-bg); }
.lb-extras .lb-slots-title { margin-bottom: 0; }
.lb-extra {
  display: flex; align-items: center; gap: 10px; width: 100%; text-align: left; padding: 10px 12px; border-radius: 12px;
  border: 1px solid var(--lb-border); background: var(--lb-surface); transition: border-color .15s ease, background .15s ease;
}
.lb-extra-check { width: 20px; height: 20px; flex-shrink: 0; border-radius: 6px; border: 1.5px solid var(--lb-muted); display: grid; place-items: center; color: transparent; }
.lb-extra[aria-pressed="true"] { border-color: var(--lb-accent); background: var(--lb-bg); }
.lb-extra[aria-pressed="true"] .lb-extra-check { background: var(--lb-accent); border-color: var(--lb-accent); color: var(--lb-on-accent); }
.lb-extra[disabled] { opacity: .6; cursor: default; }
.lb-extra[aria-pressed="true"][disabled] { opacity: 1; }
.lb-extras-submit {
  margin-top: 2px; width: 100%; padding: 10px 12px; border-radius: 12px; font-weight: 650; font-size: 14px;
  border: 1px solid var(--lb-accent); background: transparent; color: var(--lb-accent);
}
.lb-root[data-theme="dark"] .lb-extras-submit:not(.lb-active) { color: var(--lb-text); }
.lb-extras-submit.lb-active { background: var(--lb-accent); color: var(--lb-on-accent); }
.lb-extras-submit[disabled] { opacity: .55; cursor: default; }
.lb-slots { width: 100%; border: 1px solid var(--lb-border); border-radius: 16px; padding: 12px; background: var(--lb-bg); }
.lb-slots-title { display: flex; align-items: center; gap: 6px; font-size: 12.5px; font-weight: 600; color: var(--lb-muted); margin-bottom: 8px; }
.lb-slot-day + .lb-slot-day { margin-top: 10px; }
.lb-slot-day-label { font-size: 13px; font-weight: 650; margin-bottom: 6px; }
.lb-slot-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(92px, 1fr)); gap: 6px; }
.lb-slot-grid .lb-chip { text-align: center; padding: 9px 6px; border-radius: 10px; }

.lb-booking { width: 100%; border-radius: 16px; overflow: hidden; border: 1px solid var(--lb-border); background: var(--lb-bg); }
.lb-booking-head { display: flex; align-items: center; gap: 10px; padding: 12px 14px; background: color-mix(in srgb, #22c55e 12%, var(--lb-bg)); }
.lb-booking-head svg { color: #16a34a; flex-shrink: 0; }
.lb-booking-head strong { display: block; font-size: 14.5px; }
.lb-booking-head span { display: block; font-size: 12.5px; color: var(--lb-muted); }
.lb-booking-head code { font: 600 12.5px ui-monospace, SFMono-Regular, Menlo, monospace; color: var(--lb-text); white-space: nowrap; }
.lb-booking dl { margin: 0; padding: 10px 14px; display: grid; grid-template-columns: auto 1fr; gap: 6px 12px; font-size: 13.5px; }
.lb-booking dt { color: var(--lb-muted); }
.lb-booking dd { margin: 0; font-weight: 550; }
.lb-booking a { display: block; margin: 0 14px 12px; text-align: center; padding: 9px; border-radius: 10px; background: var(--lb-surface); color: var(--lb-text); font-size: 13.5px; font-weight: 600; text-decoration: none; }

.lb-typing { display: inline-flex; gap: 4px; padding: 14px 16px; }
.lb-typing i { width: 7px; height: 7px; border-radius: 50%; background: var(--lb-muted); opacity: .5; animation: lb-blink 1.2s infinite ease-in-out; }
.lb-typing i:nth-child(2) { animation-delay: .15s; }
.lb-typing i:nth-child(3) { animation-delay: .3s; }

/* Composer */
.lb-suggestions { display: flex; gap: 8px; overflow-x: auto; padding: 4px 16px 10px; scrollbar-width: none; }
.lb-suggestions::-webkit-scrollbar { display: none; }
.lb-suggestions .lb-chip { white-space: nowrap; flex-shrink: 0; }
.lb-composer { display: flex; align-items: flex-end; gap: 8px; padding: 10px 12px calc(10px + var(--lb-safe-bottom)); border-top: 1px solid var(--lb-border); }
.lb-composer textarea {
  flex: 1; resize: none; max-height: 120px; min-height: 44px; padding: 11px 14px; border-radius: 22px; border: 1px solid var(--lb-border);
  background: var(--lb-surface); font-size: 16px; line-height: 1.35; outline: none; transition: border-color .15s, background .15s;
}
.lb-composer textarea:focus { border-color: var(--lb-accent); background: var(--lb-bg); }
.lb-send { width: 44px; height: 44px; flex-shrink: 0; border: 0; border-radius: 50%; background: var(--lb-accent); color: var(--lb-on-accent); display: grid; place-items: center; transition: opacity .15s, transform .1s; }
.lb-send[disabled] { opacity: .35; cursor: default; }
.lb-send:not([disabled]):active { transform: scale(.94); }
.lb-branding { text-align: center; font-size: 11px; color: var(--lb-muted); padding: 0 0 8px; }
.lb-branding a { color: inherit; font-weight: 600; text-decoration: none; }

/* Phones: the chat takes the whole screen */
.lb-root.lb-mobile { bottom: 16px; right: 16px; }
.lb-root.lb-mobile[data-position="left"] { left: 16px; }
.lb-root.lb-mobile .lb-panel { position: fixed; inset: 0; width: 100%; height: 100%; border-radius: 0; transform: translateY(24px); }
.lb-root.lb-mobile.lb-open .lb-panel { transform: none; }
.lb-root.lb-mobile.lb-open .lb-dock { display: none; }
.lb-root.lb-mobile .lb-contact { width: 44px; height: 44px; }
.lb-root.lb-mobile .lb-contacts { margin: 0 7px; gap: 9px; }
.lb-root.lb-mobile .lb-label { max-width: 200px; }

/* Dashboard preview: the panel fills the preview frame */
.lb-root.lb-preview { inset: 0; width: 100%; height: 100%; }
/* Real chat size (as on a website): fills the small dashboard frame, never stretches on a big screen. */
.lb-root.lb-preview .lb-panel { left: auto; right: 12px; top: auto; bottom: 84px; width: min(400px, calc(100% - 24px)); height: min(680px, calc(100% - 96px)); }
.lb-root.lb-preview[data-position="left"] .lb-panel { right: auto; left: 12px; }
.lb-root.lb-preview .lb-dock { position: absolute; bottom: 12px; right: 12px; }
.lb-root.lb-preview[data-position="left"] .lb-dock { right: auto; left: 12px; }

/* Hover effects only where there is a mouse: on touch screens they stick after a tap. */
@media (hover: hover) {
  .lb-chip:hover { background: var(--lb-accent); color: var(--lb-on-accent); }
  .lb-service:hover { border-color: var(--lb-accent); box-shadow: 0 4px 16px -6px rgba(15, 23, 42, .2); }
  .lb-contact:hover { transform: translateY(-2px) scale(1.04); }
  .lb-contact:hover .lb-contact-tip, .lb-contact:focus-visible .lb-contact-tip { opacity: 1; }
}

@keyframes lb-in { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
@keyframes lb-pop { from { opacity: 0; transform: translateY(6px) scale(.96); } to { opacity: 1; transform: none; } }
@keyframes lb-blink { 0%, 80%, 100% { opacity: .25; transform: translateY(0); } 40% { opacity: .9; transform: translateY(-3px); } }
@media (prefers-reduced-motion: reduce) { *, *::before, *::after { animation: none !important; transition: none !important; } }
`;
